'use strict'

$('.js-fix-cv .pagetop').find('a').on('click',
  (e)->
    e.preventDefault()
)
